// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import util from '../../../../share/util/utils';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import cstmTable from '../../../../share/components/vue/PaginationTable';
import error from '../../../../common/nodejs/errors';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  REGISTERED: 'registered',
  INPUT_DATA: 'inputData',
  INVALID_DATA: 'invalidData',
  SAVE_DATA: 'saveData',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export default {
  name: 'requirement063',
  data() {
    return {
      isLoading: false,
      systemId: '',
      phase: PHASE.START,
      state: '',
      getVariantData: [],
      appliedModelOptionCodes: [],
      validateAppliedModel: undefined,
      validateOptionCode: undefined,
      chkValidateAppliedModel: false,
      chkValidateOptionCode: false,
      appliedModel: '',
      optionCode: '',
      twelveDigitModelCode: '',
      rowIndex: 0,
      writeCnt: 0,
      readType: '',
      writeType: '',
      exitType: '',
      displayMsg: '',
      resultApplied: '',
      resultOptionCode: '',
      isErrorVariant: false,
      modal_requirement_063: false,
      lastEvaluatedKey: null,
      readRequestId: null,
      valiantResult: [],
    };
  },

  components: {
    'cstm-table': cstmTable
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {

      switch (this.phase) {
        case PHASE.INVALID_DATA:
        case PHASE.FAILED:
          return 'danger';
        case PHASE.REGISTERED:
          return 'warning';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.START:
        case PHASE.INPUT_DATA:
        default:
          return 'secondary';
      }
    },
    /** システムテーブルのカラム */
    systemTableColumns() {
      return [
        { name: 'applied', label: this.displayMsg },
        { name: 'option_code', label: this.i18nWsKey + '.option_code' },
      ];
    },
    /** DIDの応答値の結果を判定 */
    checkDidResponse() {
      if (this.valiantResult.every(result => result === 'zero')) {
        return 'zero';
      } else if (this.valiantResult.includes('match')) {
        return 'match';
      } else {
        return 'no_match';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.displayMsg = this.i18nWsKey + '.applied_model';
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.validateAppliedModel = undefined;
      this.validateOptionCode = undefined;
      this.chkValidate = false;
      this.wsIdToType();
      this.modal_requirement_063 = true;
    },

    /** 呼び出された機能別にtypeを設定するメソッド */
    wsIdToType() {
      this.readType = 'read';
      this.writeType = 'write';
      this.exitType = 'exit';
    },

    /** Wizardを閉じる */
    closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_063 = false;
    },

    /**
     * 終了処理
     * @returns 
     */
    async exitLogic() {
      try {
        // バリアントデータ未取得エラー/DID非サポートエラーの場合は、exitAPIは実行せず画面閉じ
        if (this.isErrorVariant) {
          this.closeWizard();
          return;
        }
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: this.exitType
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 結果に関わらず、機能終了
          this.closeWizard();
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** データ読み出し処理 */
    async readData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: this.readType,
            // バリアントデータ分割取得時に必要なパラメータを渡す（初回実行時はnullが設定される）
            last_evaluated_key: this.lastEvaluatedKey,
            read_request_id: this.readRequestId,
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              // バリアントデータを保持
              this.getVariantData = response.data.user_data.variant_data ? this.getVariantData.concat(response.data.user_data.variant_data) : this.getVariantData;
              // 12桁型式を取得
              this.twelveDigitModelCode = response.data.user_data.twelve_digit_model_code;
              // DID応答値の結果を保持
              this.valiantResult.push(response.data.user_data.result);

              if (response.data.user_data.last_evaluated_key) {
                // last_evaluated_keyが存在する場合は、readAPIを再度実行
                // 2回目以降のリクエストボディに必要なパラメータを保持
                this.lastEvaluatedKey = response.data.user_data.last_evaluated_key;
                this.readRequestId = response.data.user_data.read_request_id ? response.data.user_data.read_request_id : this.readRequestId;
                await this.readData();
                break;
              }
              // バリアントデータの全件取得完了
              switch (this.checkDidResponse) {
                case 'zero':
                  // アプライドモデル・オプションコード入力画面へ遷移
                  this.inputData();
                  break;
                case 'match':
                  // 登録済み警告画面へ遷移
                  this.phase = PHASE.REGISTERED;
                  // カスタムテーブルの描画の為sleep処理を実施
                  await util.sleep(1000);
                  // is_matchがtrueのものだけを抜き出して、仕向地コードとOPコードを連結して表示
                  this.appliedModelOptionCodes = this.getVariantData.filter(item => item && item.is_match === true)
                    .map(item => {
                      return {
                        "applied": item.applied,
                        "option_code": item.destination + item.op_code,
                      };
                    });
                  break;
                case 'no_match':
                  // 終了処理を実行
                  await this.exitLogic();
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了
              // バリアントデータ未取得エラー/DID非サポートエラーの場合は、exitAPIは実行せず画面閉じ
              this.isErrorVariant = response.data?.async_code === error.WSP_DB_VARIANT_DATA_NOT_FOUND;
              // 共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** アプライドモデル・オプションコード入力画面へ遷移 */
    inputData() {
      this.phase = PHASE.INPUT_DATA;
      this.judgementTwelveDigitModel();
    },

    /** 12桁型式の判定 */
    judgementTwelveDigitModel() {
      this.appliedModel = '';
      this.optionCode = '';

      if (this.twelveDigitModelCode) {
        this.appliedModel = this.twelveDigitModelCode.slice(0, 7);
        this.optionCode = this.twelveDigitModelCode.slice(7).trim();
      }
    },

    /** 実行 */
    async execute() {
      try {
        this.isLoading = true;
        // バリデーション(入力チェック)の実行
        this.chkValidateAppliedModel = this.checkValidateAppliedModel();
        this.chkValidateOptionCode = this.checkValidateOptionCode();
        if (!this.chkValidateAppliedModel || !this.chkValidateOptionCode) {
          // アプライドモデル、オプションコードいずれかのバリデーションがエラーの場合処理終了
          return;
        }

        // アプライドモデル・オプションコード一致判定
        if (!this.chkInputParam(this.appliedModel, this.optionCode, this.getVariantData)) {
          //無効なアプライドモデルとオプションコード
          // 非サポートエラー画面へ遷移
          this.phase = PHASE.INVALID_DATA;
          return;
        }

        // 有効なアプライドモデルとオプションコード
        // 書き込み中画面へ遷移
        this.phase = PHASE.START;
        await this.saveData();
      } finally {
        this.isLoading = false;
      }
    },

    /** 
     * アプライドモデルのバリデーションチェック
     * @returns バリデーション確認結果(true：バリデーションOK/false：バリデーションエラー)
     */
    checkValidateAppliedModel() {
      this.validateAppliedModel = undefined;

      // アプライドモデルが空の場合、エラーを出す
      if (!this.appliedModel) {
        this.validateAppliedModel = { valid: true, msg: this.$t(`message.alert_validate_required`) };
        return false;
      }

      // アプライドモデルの不正文字列の確認
      if (this.checkInvalidCharacter(this.appliedModel)) {
        this.validateAppliedModel = { valid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        return false;
      }

      // アプライドモデルの桁数チェック
      if (this.appliedModel.length !== 7) {
        this.validateAppliedModel = { valid: true, msg: this.$t(`message.alert_validate_max_length`, ['7']) };
        return false;
      }

      return true;
    },

    /** オプションコードのバリデーションチェック
     * @returns バリデーション確認結果(true：バリデーションOK/false：バリデーションエラー)
     */
    checkValidateOptionCode() {
      this.validateOptionCode = undefined;

      // オプションコードの不正文字列の確認
      if (this.checkInvalidCharacter(this.optionCode)) {
        this.validateOptionCode = { valid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        return false;
      }

      // オプションコードはアプライドモデルの入力値によってバリデーションの内容が変わるため
      // アプライドモデルのバリデーションがエラーの場合は後続のチェックを実行しない
      if (!this.chkValidateAppliedModel) {
        return true;
      }

      // アプライドモデルの5桁目の値の取得
      const fifthChar = this.appliedModel.slice(4, 5);
      const regExpNum = /^(\d+)$/i;

      // 5桁目が数字かどうかを判定
      if (regExpNum.test(fifthChar)) {
        // 数字の場合、オプションコードが3桁以下かのチェック
        if (this.optionCode.length > 3) {
          this.validateOptionCode = { valid: true, msg: this.$t(`message.alert_validate_max_length`, ['3']) };
          return false;
        }
      } else {
        // 英字の場合、オプションコードが4桁以下かのチェック
        if (this.optionCode.length > 4) {
          this.validateOptionCode = { valid: true, msg: this.$t(`message.alert_validate_max_length`, ['4']) };
          return false;
        }
      }

      return true;
    },

    /**
     * 使用不可な文字列が含まれていないかの確認関数
     * @param code 対象code
     */
    checkInvalidCharacter(code) {
      // 半角英数字以外の場合は弾く
      const halfReqExp = new RegExp(/^[A-Za-z0-9]*$/);
      return !halfReqExp.test(code);
    },

    /**
     * アプライドモデルとオプションコードの一致確認
     * @param inputAppliedModel アプライドモデルの入力値
     * @param inputOptionCode オプションコードの入力値
     * @param valiantData 取得したバリアントデータ群
     * @returns 一致確認結果(true：一致/false：不一致)
     */
    chkInputParam(inputAppliedModel, inputOptionCode, valiantData) {
      let idx = 0;
      let optionCode = "";
      let patternString = "";
      let regexPattern = "";
      let chkFlg = false;

      while (idx < valiantData.length) {
        optionCode = valiantData[idx].destination + valiantData[idx].op_code;
        // アプライドモデルの入力値が取得したバリアントデータのアプライドモデルと一致すること
        if (inputAppliedModel.toUpperCase() === valiantData[idx].applied.toUpperCase()) {
          // [_] を [""]に変換
          patternString = optionCode.replace(/_/g, "").toUpperCase();
          // [*] を [.](任意の0文字以上)に変換
          regexPattern = new RegExp("^" + patternString.replace(/\*/g, ".?") + "$");
          // オプションコードの入力値が取得したバリアントデータの仕向値コード＋OPコードの連結文字列と一致すること
          if (regexPattern.test(inputOptionCode.toUpperCase())) {
            chkFlg = true;
            this.rowIndex = idx;
            break;
          }
        }
        idx++;
      }
      return chkFlg;
    },

    /** 保存処理 */
    async saveData() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: this.writeType,
            applied: this.getVariantData[this.rowIndex].applied,
            destination: this.getVariantData[this.rowIndex].destination,
            op_code: this.getVariantData[this.rowIndex].op_code,
            development_code: this.getVariantData[this.rowIndex].development_code,
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了  
              switch (response.data.user_data.result) {
                case 'ok':
                  // 正常終了画面へ遷移
                  this.resultApplied = this.getVariantData[this.rowIndex].applied;
                  this.resultOptionCode = this.getVariantData[this.rowIndex].destination + this.getVariantData[this.rowIndex].op_code;
                  this.phase = PHASE.SUCCESS;
                  break;
                case 'ng':
                  // 書込み実行回数をカウント
                  this.writeCnt += 1;
                  // 保存処理の実行回数が10回以下の場合
                  // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                  /* eslint-disable max-depth */
                  if (this.writeCnt <= 10) {
                    // VUE_APP_RETRY_INTERVALの時間分sleep
                    await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
                    // 保存処理を実行
                    await this.saveData();
                  } else {
                    // 共通エラー
                    this.showUnexpectedError();
                  }
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：共通エラー
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** その他エラーの表示 */
    showUnexpectedError() {
      this.phase = PHASE.FAILED;
    },
  },

  /** ライフサイクルイベント */
  async mounted() {
    this.init();
    // データ読み出し
    await this.readData();
  },
};